module.exports = __webpack_public_path__ + "media/application/images/wjc-b71748a176801594c3f3e42726718310c9545d7aa3012abaf94991b5212fef4a.png";